import { Navigate, useLocation, useParams } from 'react-router-dom';

// Sends a bookmarked legacy URL to its canonical path, keeping the query string and hash
// (dashboard links filter the findings list by query and open a finding's #activity).
const LegacyRedirect = ({ to }: { to: (id?: string) => string }) => {
  const { id } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${to(id)}${search}${hash}`} replace />;
};

export default LegacyRedirect;
